import { Component } from '@angular/core';
import { UserService } from '@tcc-mono/classifact/shared/data-access/classifact-api';
import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import utc from 'dayjs/plugin/utc';
import { environment } from '../environments/environment';

@Component({
  selector: 'tcc-mono-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  constructor(private _userService: UserService) {
    dayjs.locale('nl');
    dayjs.extend(utc);

    this._userService.me$.subscribe(user => {
      // Redirect only when user is strictly player-only (no other roles, not super_admin)
      const roles = user?.roles || [];
      const isPlayerOnly = Array.isArray(roles)
        ? roles.length === 1 && (roles[0]?.name || roles[0]) === 'player'
        : user && (user as any).role === 'player';

      if (isPlayerOnly && !user?.super_admin) {
        window.location.href = environment.appUrl;
      }
    });
  }
}
